import { OptionDescriptionModalTranslation, PriceDifferenceTranslation, RequestQuoteContentTranslation, SiteTranslation } from './SiteTranslation';

// tslint:disable:max-line-length

const requestQuoteDefaultTranslation: RequestQuoteContentTranslation = {
  confirmation: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Bevestigingspagina',
    buttonLink: 'Doorgaan met winkelen',
    title: 'Bedankt! Uw offerte is onderweg.',
    content: 'Onze lokale dealer zal spoedig contact met u opnemen',
  },
  goBackLink: 'Terug',
  title: 'Offerte aanvragen',
  stepsTitle: 'Wat gebeurt er met mijn aanvraag?',
  steps: [
    'Uw aanvraag wordt verzonden naar Flokk sales.',
    'Ons lokaal Flokk verkoopteam zal een voorstel opmaken.',
    'Een Flokk vertegenwoordiger zal tussen nu en het einde van de volgende werkdag contact opnemen naar aanleiding van uw verzoek',
  ],
};

const requestQuoteProcessedByDealerTranslation: RequestQuoteContentTranslation = {
  ...requestQuoteDefaultTranslation,
  confirmation: {
    ...requestQuoteDefaultTranslation.confirmation,
    content: 'Onze lokale dealer zal spoedig contact met u opnemen',
  },
  steps: [
    'Uw aanvraag wordt verzonden naar Flokk sales.',
    'Ons lokaal Flokk verkoopteam zal een voorstel opmaken.',
    'Een Flokk vertegenwoordiger zal tussen nu en het einde van de volgende werkdag contact opnemen naar aanleiding van uw verzoek',
  ],
};

const optionDescriptionModal: OptionDescriptionModalTranslation = {
  closeButton:
    'Sluiten',
};

const priceDifferenceTranslation: PriceDifferenceTranslation = {
  startsFromPriceText:
    'Starts from',
};

const translation: SiteTranslation = {
  layout: {
    siteHeader: {
      menuTitle:
        'Hoofdmenu',
      openMenuButton:
        'Menu openen',
      closeMenuButton:
        'Menu sluiten',
      skipLink:
        'Ga naar hoofdinhoud',
      navigation: {
        title:
          'Hoofdnavigatie',
      },
      search: {
        openButton:
          'Zoeken',
        title:
          'Zoekmenu',
        searchBar: {
          label:
            'Zoeken',
          placeholder:
            'Zoeken',
          clearButton:
            'Wissen',
          submitButton:
            'Zoeken',
        },
        closeButton:
          'Zoekmenu sluiten',
      },
      storeAndLanguageSelector: {
        openButton:
          'Locatie en taal wijzigen. Huidig: {currentStore}, {currentLanguage}.',
        title:
          'Locatie en taal selecteren',
        languageSelector: {
          title:
            'Taal',
        },
        storeSelector: {
          title:
            'Locatie',
        },
        closeButton:
          'Sluiten',
      },
    },
    topBar: {
      title: 'Flokk',
      chooseChairLink: 'Kies stoel',
      aboutUsLink: 'Over ons',
      inputSearchPlaceholder: 'Zoeken',
      languages: {
        chDe: 'Duits',
        chFr: 'Frans',
        deDe: 'Duits',
        dkDk: 'Deens',
        enUs: 'Engels',
        frFr: 'Frans',
        nlNl: 'Nederlands',
        nbNo: 'Noors',
        enGb: 'Engels',
        svSe: 'Zweeds',
        plPl: 'Pools',
      },
    },
    titleFormat: '{title} - Flokk - configureer uw stoel',
  },
  requestQuotePage: {
    errorMessage:
      'Er is een fout opgetreden tijdens het laden van het Hubspot formulier. Neem contact op met onze customer support afdeling. ',
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Offerte aanvragen',
    defaultContent: requestQuoteDefaultTranslation,
    contentWhenProcessedByDealer: requestQuoteProcessedByDealerTranslation,
  },
  emailMyConfigurationPage: {
    errorMessage:
      'Er is een fout opgetreden tijdens het laden van het Hubspot formulier. Neem contact op met onze customer support afdeling. ',
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Stuur configuratie naar mijn e-mail',
    confirmation: {
      pageDescriptionFormat: 'Beschrijving',
      pageTitleFormat: 'Stuur configuratie naar mijn e-mail',
      buttonLink: 'Verstuur naar mijn e-mail',
      title: 'Bedankt! Uw e-mail is onderweg. ',
      content: 'Zie uw inbox',
    },
    goBackLink: 'Ga terug naar samenvatting',
    title: 'e-mail mijn configuratie',
  },
  homePage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Homepagina',
    articleList: {
      readMore: 'Lees meer',
    },
    productList: {
      fromPriceLabel: '*From {price} inc VAT',
      productThumbnail: {
        productVariationList: {
          title: '*Variations'
        }
      }
    },
  },
  configurationSearchPage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: '*Search for configuration',
    title: 'Voer uw configuratie code ',
    description: 'in en ga naar uw configuratie',
    codeInputPlaceholder: 'Type hier de code en druk op enter.',
    configurationFinder: {
      codeWithIncorrectLengthFormat: 'Code moet exact 6 tekens zijn, of 6 tekens voorafgegaan door "M-" voor een modulaire configuratie.',
      codeInvalid: 'Opgegeven code {invalidCode} is ongeldig! Zorg ervoor dat uw code correct is ingevuld.',
      codeNotFound: 'Kan uw product configuratie code {notFoundCode} niet vinden.',
    },
  },
  configurationDetailsPage: {
    pageTitleFormat: '*{code} - Configuration details',
    pageDescriptionFormat: '*{productName} {options} {accessories}',
    title: '*Your selected configuration',
    visualizationNotAvailableText: '*Visualization not available',
    configurationInvalidOrObsolete: 'Configuration is invalid or obsolete, please configure again before purchase.',
    unableToValidateConfigurationCode: 'There was a problem with validating configuration and purchase is disabled, please try again later or contact customer support.'
  },
  confirmationPage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Orderbevestiging',
    title: 'Uitchecken',
    errorTitle: 'Er is een fout opgetreden',
    paymentConfirmed: 'Uw betaling is bevestigd. Wij hopen dat u het leuk vond om bij ons te winkelen.',
    checkYourEmail: 'Controleer uw e-mailadres voor bestel- en bezorggevens.',
    errorContent: 'Er is een fout opgetreden. Neem contact op met de support afdeling',
    orderSection: {
      title: 'Uw bestelling',
      orderNumber: 'Ordernummer',
    },
    summarySection: {
      title: 'Samenvatting',
      taxText: '+ VAT',
      totalToPayText: 'total',
      contact: {
        contactAndBilling: 'Contact & facturering',
        deliveryAddress: 'Afleveradres',
      },
    },
    designerSectionTitle: 'Weet u wie uw stoel heeft ontworpen?',
    customerStorySectionTitle: 'Weet u hoe je moet zitten?',
    readMore: 'Lees meer',
    contactUsSection: {
      text: 'Als u vragen heeft neem dat contact op met onze',
      linkText: 'customer service',
    },
  },
  checkoutPage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Uitloggen',
    title: 'Uitchecken',
    goBackLink: 'Terug',
    progress: {
      title: 'Uitloggen',
      deliveryStep: 'Levering',
      paymentStep: 'Betaling',
      confirmationStep: 'Bevestiging',
    },
    goToPaymentButton: 'Bevestiging & betalen met',
    paymentMethodLabel: 'Betaalmethode kiezen',
    orderAndPayButton: 'Bestellen en betalen',
    submitButton: 'Verzenden',
    paymentPoweredByText: '*We use a payment solution from',
    addressForm: {
      city: {
        name: 'Stad',
        placeholder: 'Voer stad in',
        fieldRequired: 'Stad is verplicht',
      },
      country: {
        name: 'Land',
        placeholder: 'Voer land in ',
        fieldRequired: 'Land is verplicht',
      },
      street: {
        name: 'Straat',
        placeholder: 'Voer straat in',
        fieldRequired: 'Straat is verplicht',
      },
      streetNumber: {
        name: 'Huisnummer',
        placeholder: 'Voer huisnummer in',
        fieldRequired: 'Huisnummer is verplicht',
      },
      zipCode: {
        name: 'Postcode',
        fieldRequired: 'Postcode is verplicht',
        wrongFormat: 'Ingevoerde postcode is niet geldig',
      },
      availableCountries: {
        POL: 'Polen',
        NOR: 'Noorwegen',
        CHE: 'Zwitserland ',
        DEU: 'Duitsland',
        DNK: 'Denemarken',
        FRA: 'Frankrijk',
        NLD: 'Nederland',
        SWE: 'Zweden',
        GBR: 'Verenigd Koninkrijk',
        USA: 'Verenigde Staten',
      },
      addressLine1: {
        name: 'Adres regel 1',
        placeholder: '*',
        fieldRequired: 'Adres regel 1 is verplicht',
        wrongFormat: '*',
      },
      addressLine2: {
        name: 'Adres regel 2',
        placeholder: '*',
        fieldRequired: 'Adres regel 2 is verplicht',
        wrongFormat: '*',
      },
      recipient: {
        name: 'Ontvanger',
        placeholder: '*',
        fieldRequired: 'Ontvanger is verplicht',
        wrongFormat: '*',
      },
    },
    contactForm: {
      contactDetails: 'Contactgegevens',
      email: {
        name: 'E-mail',
        placeholder: 'E-mail invoeren',
        fieldRequired: 'E-mail is verplicht',
        wrongFormat: 'Ingevoerde e-mailadres is niet geldig',
      },
      phone: {
        name: 'Telefoon',
        placeholder: 'Telefoon invoeren',
        fieldRequired: 'Telefoon is verplicht',
        wrongFormat: 'Ingevoerde telefoonnummer is niet geldig',
      },
      firstName: {
        name: 'Voornaam',
        placeholder: 'Voornaam invoeren',
        fieldRequired: 'Voornaam is verplicht',
        wrongFormat: 'Ingevoerde telefoon voorvoegsel is niet geldig',
      },
      phonePrefix: {
        name: 'Telefoon voorvoegsel',
        placeholder: '+ _ _',
        fieldRequired: 'Telefoon voorvoegsel is verplicht',
      },
      lastName: {
        name: 'Achternaam',
        placeholder: 'Achternaam',
        fieldRequired: 'Achternaam is verplicht ',
      },
      companyName: {
        name: 'Bedrijfsnaam (optioneel)',
        placeholder: '*',
      },
      taxId: {
        name: '*Company Tax Id',
        placeholder: '',
        fieldRequired: '*Company Tax Id is required',
      },
    },
    shippingMethodSection: {
      subtitle: 'Delivery method',
      shippingMethod: {
        name: 'Shipping Method',
        fieldRequired: 'This field is required',
      },
    },
    deliveryAddressSection: {
      subtitle: 'Afleveradres',
      billingAndDeliveryAreTheSameText: 'Factuur- en bezorgadres zijn hetzelfde',
      deliveryInfoText: 'Gratis levering aan huis in 10-15 dagen',
    },
    paymentMethods: {
      supportedCreditCardsMessage: {
        acceptedCreditCardsText: '*We accept the following payment cards',
      },
      klarna: {
        selectPaymentCategory: `*Please select payment category:`
      }
    },
    readyToOrderSection: {
      subtitle: 'Klaar om te bestellen?',
      termsAndConditions: {
        termsAndConditionLinkName: 'Algemene voorwaarden',
        name: 'Dit veld is verplicht',
        placeholder: '*',
        fieldRequired: 'Dit veld is verplicht',
      },
      subscription: 'Ik wil graag extra ontvangen…',
    },
    readyToOrderPaymentSection: {
      subtitle: 'Klaar om te bestellen?',
    },
    errors: {
      creatingOrderFailed:
        'Kan bestelling niet plaatsen. Probeer het opnieuw of neem contact op met onze sales support. ',
      initializingPaymentFailed: 'Betaling is mislukt. Probeer het opnieuw of neem contact op met onze sales support.',
      authorizingPaymentFailed: 'Autorisatie mislukt. Probeer het opnieuw of neem contact op met onze sales support.',
      finalizingPaymentFailed: 'Betaling is mislukt. Probeer het opnieuw of neem contact op met onze sales support.',
    },
    discountCodeForm: {
      applyButton: '*Apply',
      discountCodeIsAppliedMessage: '*The "{code}" discount code is applied.',
      discountCodeIsInvalidOrExpiredError: '*The code you entered is invalid or has expired.',
      doYouHaveDiscountCodeText: '*Do you have a promotion or campaign code?',
      enterCodeText: '*Insert code here',
      label: '*Promo code',
    },
  },
  checkoutShortcutPage: {
    pageTitleFormat:
      'Checkout shortcut',
    pageDescriptionFormat:
      '',
    errors: {
      addingProductToCartFailed:
        'Unable to purchase product configuration with code {code}. Please contact customer support.',
      gettingProductConfigurationFailed:
        'Unable to retrieve information about product configuration with the code {code}. Please refresh page or contact customer support.',
    }
  },
  configurationPage: {
    pageDescriptionFormat: '{productName} {options} {accessories}',
    pageTitleFormat: '{productName} - Configuratie ',
    productDetails: {
      documentsSection: 'Documenten',
      moreInformationSection: 'Meer informatie',
      specificationSection: 'Specificaties',
    },
    fabricCuratedSelectionBasedFilter: {
      label: 'Stoffenassortiment',
      newText: 'Nieuw',
    },
    showFiltersText: '*Show filters',
    hideFiltersText: '*Hide filters',
    productModels: {
      chooseModelText: '*Choose your model',
      modelSelectorWithLoader: {
        noOtherModelsAvailable: '*There are no other models available.',
      },
    },
    options: {
      title: 'Personaliseer uw stoel',
      priceGroup: 'Prijsgroep',
      textSelected: 'Geselecteerd',
      fabricFilters: {
        noFabricsAvailable: 'Er zijn geen stoffen die overeenkomen met uw voorkeuren.',
        clearButton: 'Wissen',
        defaultFilterName: 'Allemaal',
        collectionFilterLabel: 'Collectie'
      },
      fabricFacetFilters: {
        filtersTitle: 'Kies je stof',
        openFiltersButtonLabel: 'Filters',
        colorFilterLabel: 'Kleur',
        leadTimeFilterLabel: 'Levertijd',
        priceGroupFilterLabel: 'Prijsgroep',
        fabricFeaturesFilterLabel: 'Kenmerken',
        priceGroupShortLabel: 'PG',
        applyFiltersButtonLabel: 'Resultaten tonen',
        priceGroupFilterDescription: 'Van de goedkoopste tot de duurste prijsgroep.',
        clearAllFiltersButtonLabel: 'Alles wissen',
        shippingTimeText: {
          deliveredWithin: 'Geleverd binnen',
          day: 'dag',
          days: 'dagen',
          week: 'week',
          weeks: 'weken',
        },
      },
      priceDifferenceTranslation: priceDifferenceTranslation,
    },
    accessories: {
      title: 'Accessoires',
      accessory: {
        removeButton: 'Verwijderen',
        addButton: 'Toevoegen',
        textSelected: 'Geselecteerd',
        priceDifferenceTranslation: priceDifferenceTranslation,
      },
    },
    summary: {
      title: 'Uw bestelling overzicht',
      accessoriesSubtitle: 'Accessoires',
      requestQuoteButton: 'Vraagprijs',
      emailConfirmationButton: 'E-mail mijn configuratie',
      limitedChairQuantity: 'Neem contact met ons op om meer {max} stoelen te bestellen',
      checkoutButton: 'Uitchecken',
      editConfigurationLink: 'Bewerken',
      expectedShipment: {
        expectedShipment: '*Ready for shipping within',
        days: '*working days',
      },
      quantityInput: {
        outOfRangeWarning: 'De waarde moet tussen {min} en {max} zijn',
      },
      saveYourConfigurationHereButton: 'Sla uw configuratie op',
      backButton: 'Terug',
      shareSection: {
        title: 'Bewaar uw configuratie',
        yourConfigurationUrl: 'Uw configuratie link',
        downloadAsPdf: 'Downloaden als PDF',
        downloadVisualizations: 'Download visualisaties',
        downloadSingleVisualization: 'Download visualisatie',
        codeShare: {
          codeTitle: 'Uw configuratiecode ',
          copyCode: {
            label: 'Kopieer code',
            textCopiedLabel: 'Kopiëren',
          },
        },
        copyLink: {
          label: 'Kopieer link',
          textCopiedLabel: 'Kopiëren',
        },
        generateBarcode: {
          title:
            'Uw barcode',
          button:
            'EAN 13 genereren'
        },
        closeButton: 'Sluiten',
      },
      findLocalDealerSection: {
        title: 'Waar is Flokk?',
        button: 'Vind uw dealer',
      },
    },
    restrictions: {
      accessorySelection: {
        header: {
          userSelectionNotRequiredFormat: 'Weet u zeker dat u {itemName} wilt toevoegen als accessoire?',
          userSelectionRequiredFormat: 'Als u {itemName} wilt toevoegen moeten uw voorkeuren aangepast worden.',
        },
        automaticDeselectionOfAccessoriesFormat:
          'Gekozen accessoire is niet beschikbaar {itemsToDeselect}. Als u deze accessoire kiest zal onderstaande uit uw bestelling worden verwijderd.',
      },
      optionSelection: {
        header: {
          userSelectionNotRequiredFormat: `Weet u zeker dat u de optie {itemName} wilt wijzigen?`,
          userSelectionRequiredFormat: `Als u {itemName} wilt wijzigen moet u uw voorkeuren aanpassen.`,
        },
        automaticDeselectionOfAccessoriesFormat:
          'De gekozen optie is niet beschikbaar met {itemsToDeselect}. Als u deze accessoire kiest zal onderstaande uit uw bestelling worden verwijderd.',
      },
      itemNotAvailableWithFormat: '{itemToSelect} is niet beschikbaar met {itemsToDeselect}.',
      itemsSeparator: ' en ',
      selectMatchingOption: ' Hieronder vindt u opties die overeenkomen.',
      cancelButton: 'Annuleren',
      applyButton: 'Akkoord, veranderen',
      closeButton: 'Sluiten',
      selectedText: 'Geselecteerd',
    },
    tabs: {
      fabrics: {
        name: 'Stoffen',
      },
      options: {
        name: 'Opties',
      },
      accessories: {
        name: 'Accessoires',
      },
      summary: {
        name: 'Samenvatting',
      },
    },
    productNotAvailableInCurrentStoreWarning: {
      messageFormat:
        'Dit product kunnen we momenteel helaas niet weergeven. Als je vragen hebt, aarzel dan niet om contact op te nemen met onze klantenservice op info@flokk.com.',
    },
    productInactiveWarning: {
      discontinued: '*This is a discontinued product',
      generic: '*Product is not available',
      genericWithReason: '*Product is not available: {reason}'
    },
    obsoleteCodeModal: {
      notAvailable: {
        title: 'Stoel configuratie is niet beschikbaar.',
        intro: 'Gegeven product configuratie is niet beschikbaar.',
        introWithCodePart1: 'Gegeven product configuratie met de code',
        introWithCodePart2: 'is niet beschikbaar.',
        explanation: 'De volgende onderdelen of materialen kunnen niet meer worden gebruikt:',
      },
      restricted: {
        title: 'Stoel configuratie is niet geldig.',
        intro: 'Gegeven product configuratie is niet geldig.',
        introWithCodePart1: 'Gegeven product configuratie met de code',
        introWithCodePart2: 'is niet geldig.',
        explanation: 'Dit kan worden veroorzaakt door wijzigingen in de product configuratie.',
      },
      footer: 'Please configure your chair once again.',
      closeButton: 'Close',
    },
    optionDescriptionModal,
    metaTitleFormat: 'Mijn  {productName}',
    metaDescriptionFormat: '{productName}: {options}',
    priceTaxText: 'inclusief BTW',
  },
  modularConfiguratorPage: {
    pageDescriptionFormat: '{productName} {options} {accessories}',
    pageTitleFormat: '{productName} - Configuratie',
  },
  storeAndLanguageSelector: {
    title: 'Kies uw land of taal',
    storeSelectorLabel: 'Land',
    languageSelectorLabel: 'Taal',
  },
  storeSelectorPopup: {
    title: 'Bent u vanuit {region} aan het browsen?',
    description: 'Ga naar onze {region}-site voor de beste ervaring, met producten, details en opties afgestemd op uw regio.',
    descriptionIfStoreSelectedByLocation: `Voor de beste ervaring hebben we u naar de winkel gebracht, met producten, prijzen en informatie afgestemd op uw regio. Heeft u liever een andere locatie? Kies dan hieronder eenvoudig een andere regio.`,
    selectStoreLabel: 'Selecteer regio',
    continueButton: 'Doorgaan',
    stayHereButton: 'Blijf hier',
  },
  initialStoreSelectorModal: {
    title: 'Welkom!',
    description: 'Kies uw land om de relevante informatie te zien waar u naar zoekt',
    buttonContinue: 'Doorgaan',
    inputPlaceholder: 'Selecteer uw land',
    languageInputPlaceholder: 'Selecteer uw taal',
    linkLabelInternationalStore: 'Ga naar internationale pagina',
    noOptionMessage: 'Dit land is niet gevonden',
    noLanguageMessage: 'Deze taal is niet gevonden',
  },
  noConnectionModal: {
    title: 'Oeps!',
    content: 'Geen internetverbinding gevonden',
    continueLink: 'Ga verder',
    buttonSeparator: 'of',
    refreshButton: 'Ververs pagina',
    closeButton: 'Sluiten',
  },
  emptyCartPage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Lege winkelwagen',
    basketEmptyLine1: 'Maak uw winkelwagen leeg',
    basketEmptyLine2: 'maar dat hoeft het niet te zijn',
    continueButton: 'Ga verder met winkelen',
  },
  pageNotFound: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Pagina niet gevonden',
    content: 'We kunnen de pagina die u zoekt niet vinden.',
    title: 'oh nee!',
    buttonLink: 'Terug naar home',
  },
  generalErrorPage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Algemene fout',
    title: 'Interne server fout',
    content: 'Probeer alstublieft opnieuw',
    buttonLink: 'Probeer opnieuw',
  },
  invalidCodePage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Ongeldige pagina code',
    title: 'Ongeldige configuratie code',
    content: 'Geef geldige op',
    buttonLink: 'Terug naar Flokk',
  },
  productSpecificationPage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Product specificatie',
    accessoriesSection: 'Accessoires',
    linkTitle: 'Uw configuratie link',
    codeTitle: 'Uw configuratiecode ',
    pricesSection: {
      unitPrice: 'Prijs per unit',
      quantity: 'Qty',
      subtotalPrice: 'Subtotaal',
    },
    dataSection: {
      title: 'Gegevens',
      brand: 'Merk',
      code: 'Artikel nummer',
    },
  },
  storeLocatorPage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Vindt dealers, showroom en Flokk kantoren',
    heading: 'Vind dealer',
    storeSearch: {
      noDealersText: 'Sorry, we hebben geen dealers of kantoren in dit gebied',
      noDealersWithFiltersText:
        'Sorry, we hebben geen dealers of kantoren in dit gebied dit overeenkomen met uw filters.',
      filterResultText: '{storesNumber} locatie gevonden',
      storeLocatorInput: {
        label: 'Vind dealer',
        placeholder: 'Stad, staat of postcode',
        orText: 'of',
        currentLocationText: 'gebruik huidige locatie',
        disabledGeolocationText: 'Geolocatie is uitgeschakeld',
        unavailableGeolocationText: 'Geolocatie is niet beschikbaar',
        tryAgainText: 'Probeer opnieuw',
      },
      storeLocatorFilters: {
        title: 'Filters',
        placesLabel: 'Type plaats',
        brandLabel: 'Merk',
      },
    },
    storeTypes: {
      Showroom: 'Showroom',
      Shop: 'Shop',
    },
    details: {
      webSite: 'Website',
      address: 'Adres',
      directionLink: 'Routebeschrijving',
      email: 'E-mail',
      openHours: 'Openingstijden',
      phone: 'Telefoon',
      closeButton: 'Sluiten',
      backButton: 'Terug',
    },
  },
  cart: {
    summary: {
      deliveryFee: 'Gratis levering',
      subTotal: 'Price before VAT',
      totalTaxFormat: 'BTW ({taxTotal}%)',
      subTotalWithTax: 'Total price including VAT',
      totalToPay: '*Total To Pay',
      moreInformationText: 'Meer informatie',
      lessInformationText: 'Minder informatie',
      quantityText: 'Oty',
      shippingTimeText: {
        deliveredWithin: '*Delivered within',
        day: '*day',
        days: '*days',
        week: '*week',
        weeks: '*weeks',
      },
      configurationCodeLabel: 'ID',
      deliveryCostUnavailable: 'Select shipping method',
      freeDeliveryText: 'Gratis levering aan huis',
      taxText: '+ BTW',
      discount: '*Discount',
      surcharges: {
        'eco-tax': '*Eco tax'
      },
    },
  },
  redirectionWarningModal: {
    closeButton: 'Sluiten',
    title: 'U wordt binnen enkele seconde automatisch doorgestuurd. Bewerk het scherm om de omleiding te annuleren',
  },
  scrollToTop: {
    button: 'Bovenaan de pagina',
  },
  productFamilyPage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Product pagina',
    overviewSection: {
      name: 'Overzicht',
    },
    designerSection: {
      name: 'Designer',
      designedBy: 'Ontworpen door',
      readMore: 'Lees meer',
    },
    relatedProducts: {
      name: '*RelatedProducts',
      title: 'Misschien vind uw ook leuk',
    },
    productUserStories: {
      name: 'Projecten',
      readMore: 'Lees meer',
      title: 'Project',
    },
    layoutsSection: {
      name: 'Overzicht',
    },
    modularLayouts: {
      title: 'Ontdek configuraties',
      description:
        'Elke opstelling is verkrijgbaar in diverse kleuren en configuraties. Kies een startpunt en ga verder in de pCon-configurator om er iets unieks van te maken.',
      configureFromScratchText: 'Staat uw opstelling er niet bij?',
      configureFromScratchButton: 'Begin vanaf nul',
      configureFromScratchMobileButton: 'Ontwerp zelf',
      configureLayoutButton: 'Configureer deze opstelling',
      configuratorModal: {
        title: 'Configurator',
        closeButton: 'Configurator sluiten',
        triggerTooltip: 'Opent de pCon-configuratietool',
        fromScratchLoadingText: 'U gaat naar de pCon-configuratietool',
        fromLayoutLoadingText: 'Uw configuratie wordt geladen in pCon',
        confirmation: {
          title: 'Heeft u uw aanvraag afgerond?',
          description:
            'Uw configuratie kan hier niet worden opgeslagen. Wilt u deze naar ons sturen, rond dan eerst de aanvraag in de tool af voordat u deze sluit',
          closeButton: 'Toch sluiten',
          continueButton: 'Verder configureren',
        },
      },
    },
    modelsSection: {
      name: 'Modellen',
      productInfo: {
        priceSection: {
          taxText: 'inclusief BTW',
          fromText: 'van',
        },
        popularDesigns: {
          title: 'Populair ontwerp',
        },
        actions: {
          configureChairButton: 'Maak uw eigen ontwerp',
          askForPriceButton: 'Vraag om prijs',
          externalModularProductHint: 'Snel een offerte nodig? Vraag er direct een aan. Wilt u het afgestemd op uw ruimte? Ontwerp uw eigen opstelling in de pCon-configurator.',
          goToCheckoutButton: 'Voeg toe aan winkelwagen',
          whereToBuyButton: '*Where to buy',
        },
        whereToBuy: {
          text: '*We sell our products through a network of authorized partners.',
          designCustomChairText:
            '*However, if you’d like to create a bespoke chair please design your own above and we’ll come back to you with a price.',
        },
      },
      productModelSelector: {
        heading: 'Kies uw variant',
      },
      modelViewer: {
        hint: 'Klik op afbeelding om de zoommodus te openen',
      },
    },
    productModelDetailsSection: {
      assetsDownloader: {
        downloadAllButton: 'Download allemaal',
        other: 'Anderen',
        categories: {},
      },
      downloadsSectionTitle: 'Downloaden',
      environmentalDataSection: {
        averagedValuesDisclaimerText:
          'Alle waarden zijn gemiddelden voor dit model, voor sommige producten kunnen de waarden afwijken. De gepresenteerde waarden zijn gebaseerd op beschikbare EPD’s per product, ofwel de +A1:2013 of +A2:2019 standaard, en zullen voortdurend worden bijgewerkt op basis van nieuwe verklaringen.',
        energyUsageMjText: '*Energy usage',
        co2EmissionKgText: '*Carbon dioxide emission',
        recyclableMaterialsText: 'hernieuwbare materialen',
        recycledAluminiumText: '*recycled aluminium',
        recycledMaterialsTitle: '*Ratio of recycled materials',
        recycledMaterialsText: 'Gerecycled materiaal',
        recycledPlasticText: '*recycled plastic',
        recyclableMaterialsTitle: '*Recycling rate',
      },
      environmentalDataSectionTitle: 'Milieugegevens',
      name: 'Details',
      specificationSectionTitle: 'Specificatie',
    },
    suggestedConfigurationsSection: {
      name: 'Variaties',
      title: 'Bent u op zoek naar iets speciaals?',
      subtitle: 'Kies tussen opties zoals kleur, stoffen, materialen, accessoires en meer. ',
      buttonText: 'Maak uw eigen ontwerp',
    },
    gallerySection: {
      name: 'Galerij',
    },
    userGuideVideoSection: {
      name: '',
      videoTitle: 'Gebruikershandleiding',
    },
  },
  viewerPage: {
    pageDescriptionFormat: 'Beschrijving',
    pageTitleFormat: 'Viewer',
  },
  zoomModal: {
    closeButton: 'Sluiten',
  },
  common: {
    chairVisualization: {
      zoomHintText: 'Raak aan om in/uit te zoomen',
      hintText: 'Klik op afbeelding om de zoommodus te openen',
      renderingError: '*Sorry, we are not able to load visualisation for this configuration.',
      webGLUnsupportedError:
        '*Sorry, we are not able to load visualisation, because WebGL is not supported in your browser.',
    },
    tags: {
      clearResults: 'Verwijder allemaal',
    },
  },
  catalogPage: {
    pageTitleFormat: 'Producten',
    pageDescriptionFormat: 'Vind uw stoel ',
    filterBar: {
      name: 'Filters',
      results: 'Resultaten: {results}',
      searchLabel: 'Zoeken',
      searchPlaceholder: 'Zoeken op naam of code',
    },
    configurationFinder: {
      codeWithIncorrectLengthFormat: 'Value should have exact {expectedLength} zijn.',
      codeInvalid: 'Opgegeven code {invalidCode} is ongeldig! Zorg ervoor dat uw code correct is ingevuld.',
      codeNotFound: 'Kan uw product configuratie code {notFoundCode} niet vinden.',
    },
    productFamily: {
      showMoreProducts: 'Meer opties beschikbaar',
    },
    searchForConfigurationText: 'Al een ontwerp gemaakt? Vind jouw configuratie!',
    noResults: 'Er zijn geen bestanden die aan uw criteria voldoen',
    pagination: {
      title: 'Paginering',
    },
  },
  disclaimer: {
    messagePart1: 'Het voorbeeld van de kleur is afhankelijk van uw apparaat of scherminstelling ',
    link: 'neem contact op',
    messagePart2: ' op als u hulp nodig heeft met het kiezen van de juiste kleur en/of stof.',
  },
  requestQuoteLink: {
    link: 'Kopen voor een bedrijf? Vraag hier uw offerte aan. ',
  },
  unauthorizedErrorPage: {
    pageDescriptionFormat: '*Description',
    pageTitleFormat: '*Unauthorized',
    title: '*Unauthorized',
    content: '*Access is allowed only for registered users.',
    buttonLink: '*Login',
  },
  forbiddenErrorPage: {
    pageDescriptionFormat:
      '*You do not have necessary permissions to access this page.',
    pageTitleFormat:
      '*Forbidden',
    title:
      '*Oh, no!',
    content1:
      '*You do not have the necessary permissions to access this page. You can ',
    logout:
      'log out',
    content2:
      ' and try another account or contact Flokk support.',
    buttonLink:
      '*Take me home'
  },
  downloadsPage: {
    downloadList: {
      download: {
        downloadButton: 'Downloaden',
      },
      emptyScreen: {
        title: 'Er zijn geen bestanden die aan uw criteria voldoen. ',
        description: 'Sorry, we hebben niet gevonden waar u naar op zoek bent. Probeer alstublieft andere filters',
      },
      results: 'Er zijn {results} bestanden die aan uw criteria voldoen.',
      pagination: {
        title: 'Paginering',
      },
    },
    filters: {
      title: 'Filters',
      brandsFilter: {
        name: 'Populaire merken',
      },
      categoryFilter: {
        name: 'Categorie',
        fileTypeFilter: {
          name: 'Bestandstype',
        },
        resultsCounter: 'Alle resultaten',
      },
      downloadAllButton: 'Alles downloaden',
    },
    pageTitleFormat: 'Downloaden',
    pageDescriptionFormat: 'Zoek en download product informatie, zoals factsheets, afbeeldingen, CADs etc.',
  },
  readyMadeProductPage: {
    overviewSection: {
      name: '*Overview',
    },
    variationsSection: {
      name: '*Variations',
    },
    specificationSection: {
      name: '*Specification',
    },
    productDetailsSection: {
      specificationSectionTitle: '*Specification',
      maintenanceSectionTitle: '*Maintenance',
      downloadsSectionTitle: 'Downloaden',
      assetsDownloader: {
        downloadAllButton: 'Download allemaal',
        other: 'Anderen',
        categories: {},
      },
      productCare: {
        downloadGuide: '*Download guide here',
      },
    },
    productVariations: {
      addToCartButton: '*Add to cart',
      buyButton: '*Buy',
      deliveryTime: {
        deliveryTime: '*Delivery time',
        day: '*day',
        days: '*days*',
        week: '*week',
        weeks: '*weeks*',
      },
      priceIncludingTax: '*Incl. Tax, plus shipping cost',
      deliveryTimeAnnotation: '** Delivery time may be longer for some configurations',
      modelViewer: {
        hint: 'Klik op afbeelding om de zoommodus te openen',
      },
      customizationSection: {
        textLine1: '*Looking for something different?',
        textLine2: '*You can',
        linkText: '*customise your choice here',
      },
      productOptions: {
        fabricInfo: {
          text: '*Fabric information:',
          optionDescriptionModal,
        },
        fabricDescriptionCannotBeLoadedError:
          '*Sorry, something went wrong. Cannot load the information about the fabric.',
      },
    },
    productCarousel: {
      title: '*Others have also looked at these chairs',
    },
  },
};

export default translation;
